import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircleIcon } from '@heroicons/react/outline';

const PaymentCancel = () => {
  return (
    <motion.div
      className="max-w-sm mx-auto mt-20 bg-white rounded-2xl shadow-card-hover overflow-hidden border border-gray-100 text-center"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="h-1 w-full bg-gradient-to-r from-purple-500 via-pink-500 to-red-400" />
      <div className="p-8">
        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.15, type: "spring", stiffness: 150 }}>
          <XCircleIcon className="h-12 w-12 text-red-400 mx-auto mb-5" />
        </motion.div>

        <h1 className="text-lg font-bold text-gray-900 mb-2">Payment Cancelled</h1>
        <p className="text-xs text-gray-500 mb-6 leading-relaxed">
          Your payment was not processed. If you encountered issues, our support team is here to help.
        </p>

        <div className="flex flex-col sm:flex-row gap-2 justify-center">
          <Link to="/pricing"
            className="bg-purple-600 text-white py-2 px-5 rounded-lg text-xs font-bold uppercase tracking-wider hover:bg-purple-700 transition-colors">
            Return to Pricing
          </Link>
          <a href="mailto:support@paperdigest.xyz"
            className="bg-gray-100 text-gray-600 py-2 px-5 rounded-lg text-xs font-semibold hover:bg-gray-200 transition-colors">
            Contact Support
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default PaymentCancel;
